import { images } from './images';

export const services = [
  {
    slug: 'optimisation-achats',
    title: 'Optimisation des achats',
    short: 'Négocier mieux, acheter juste et réduire durablement vos coûts.',
    description:
      'J’analyse vos dépenses, identifie les gisements d’économies et renégocie vos contrats fournisseurs avec une approche structurée par catégorie. L’objectif : des gains rapides, mesurables, et qui tiennent dans le temps.',
    points: ['Analyse des dépenses', 'Renégociation fournisseurs', 'Stratégies par catégorie', 'Appels d’offres'],
    outcome: 'Jusqu’à −15 % sur les catégories traitées',
    image: images.meeting,
  },
  {
    slug: 'supply-chain',
    title: 'Gestion de la supply chain',
    short: 'Fiabiliser vos approvisionnements, vos stocks et vos flux logistiques.',
    description:
      'De la prévision de la demande au pilotage des stocks, je remets de la fluidité dans vos flux : moins de ruptures, moins de surstocks, un meilleur taux de service et un besoin en fonds de roulement maîtrisé.',
    points: ['Planification des approvisionnements', 'Optimisation des stocks', 'Flux logistiques', 'Taux de service'],
    outcome: '−30 % de stocks dormants en moyenne',
    image: images.warehouse,
  },
  {
    slug: 'conseil-organisation',
    title: 'Organisation & processus',
    short: 'Structurer la fonction achats et fiabiliser vos processus.',
    description:
      'Organisation de l’équipe, rôles et responsabilités, processus Procure-to-Pay, indicateurs de performance, outils : je vous aide à bâtir une fonction achats lisible, efficace et alignée sur la stratégie de l’entreprise.',
    points: ['Diagnostic organisationnel', 'Processus Procure-to-Pay', 'Tableaux de bord & KPI', 'Choix d’outils'],
    outcome: 'Des processus clairs, des délais divisés par deux',
    image: images.hero,
  },
  {
    slug: 'gestion-fournisseurs',
    title: 'Performance fournisseurs',
    short: 'Transformer votre panel en véritable réseau de partenaires.',
    description:
      'Segmentation du panel, évaluation de la performance, plans de progrès, gestion des risques et de la dépendance : je mets en place une relation fournisseur exigeante et durable.',
    points: ['Segmentation du panel', 'Évaluation & audits', 'Gestion des risques', 'Plans de progrès'],
    outcome: '+150 fournisseurs évalués et suivis',
    image: images.port,
  },
  {
    slug: 'projets-strategiques',
    title: 'Projets stratégiques',
    short: 'Piloter vos projets achats à fort enjeu, de bout en bout.',
    description:
      'Make-or-buy, relocalisation, sourcing international, intégration post-acquisition, déploiement d’un ERP : je prends en charge le pilotage de vos projets structurants, avec méthode et sens du résultat.',
    points: ['Make-or-buy', 'Sourcing international', 'Intégration post-acquisition', 'Déploiement ERP'],
    outcome: 'Des projets livrés dans les délais et le budget',
    image: images.port,
  },
  {
    slug: 'management-transition',
    title: 'Management de transition',
    short: 'Une direction achats expérimentée, opérationnelle dès la première semaine.',
    description:
      'Départ, absence, transformation à conduire : j’interviens en tant que directrice achats ou supply chain de transition pour assurer la continuité, mener les chantiers prioritaires et préparer la suite.',
    points: ['Direction achats par intérim', 'Pilotage d’équipe', 'Conduite du changement', 'Recrutement du successeur'],
    outcome: 'Opérationnelle sous 7 jours',
    image: images.portrait,
  },
];
